import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
})
export class HomeHeaderComponent {
  @Input() icon?: string;
  @Input() title?: string;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() see_all: EventEmitter<void> = new EventEmitter<void>();
}
